var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      class: ["flipping-card", _vm.statusData.cardType],
      style: [
        { height: _vm.cardHeight + "px" },
        { width: _vm.cardWidth + "px" },
      ],
    },
    [
      _c(
        "div",
        { staticClass: "flipping-card__inner" },
        [
          _c("vue-flip", {
            attrs: { height: "100%", width: "100%" },
            scopedSlots: _vm._u([
              {
                key: "front",
                fn: function () {
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "flipping-card__front",
                        style:
                          "background-image: url('" +
                          (_vm.card.imageUrl +
                            "?wid=1600&hei=900&fmt=jpeg&op_usm=1,1,5,0&resMode=sharp2&fit=crop&qlt=75,0") +
                          "')",
                        attrs: { "aria-hidden": _vm.flipped },
                      },
                      [
                        _c("div", {
                          staticClass: "heading",
                          domProps: {
                            innerHTML: _vm._s(_vm.card.propertyName),
                          },
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "badge",
                          domProps: { innerHTML: _vm._s(_vm.badgeFrontText) },
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "message",
                          domProps: {
                            innerHTML: _vm._s(_vm.meetingMessageText),
                          },
                        }),
                        _vm._v(" "),
                        _c("button", {
                          staticClass: "button--primary white size-md",
                          attrs: { tabindex: _vm.flipped ? "-1" : "0" },
                          domProps: {
                            textContent: _vm._s(
                              _vm.tc("reservations.actionLabel")
                            ),
                          },
                          on: { click: _vm.flipIt },
                        }),
                      ]
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "back",
                fn: function () {
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "flipping-card__back",
                        attrs: { "aria-hidden": !_vm.flipped },
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "flipping-card-close",
                            attrs: {
                              tabindex: _vm.flipped ? "0" : "-1",
                              "aria-label": _vm.tc(
                                "reservations.closeButtonLabel"
                              ),
                            },
                            on: { click: _vm.flipIt },
                          },
                          [
                            _c("span", {
                              staticClass: "icon icon-close-v2",
                              attrs: { "aria-hidden": "true" },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "vue-custom-scrollbar",
                          {
                            staticClass: "scroll-area",
                            style: [{ height: _vm.cardHeight + "px" }],
                            attrs: { settings: _vm.scrollSettings },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "flipping-card__scroll" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "dashboard-table dashboard-table--card",
                                  },
                                  [
                                    _c("div", {
                                      staticClass: "badge",
                                      domProps: {
                                        innerHTML: _vm._s(_vm.badgeBackText),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "confirmation full-span-column cell--border-bottom cell--flex",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "confirmation-wrapper",
                                          },
                                          [
                                            _c("img", {
                                              staticClass: "logo",
                                              attrs: {
                                                src:
                                                  _vm.card.propertyLogoUrl +
                                                  "?fmt=png-alpha",
                                                alt: _vm.card.propertyLogoAlt,
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("div", [
                                              _c("div", {
                                                staticClass: "dash-label",
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.tc(
                                                      "reservations.confirmationLabel"
                                                    )
                                                  ),
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass: "dash-content",
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.card.number
                                                  ),
                                                },
                                              }),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "date-block" }, [
                                      _c("div", { staticClass: "date-in" }, [
                                        _c("div", {
                                          staticClass: "dash-label",
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.tc(
                                                "reservations.checkinLabel"
                                              )
                                            ),
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "dash-content" },
                                          [
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("dayFilter")(
                                                    _vm.card.startDate
                                                  )
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("dateFilter")(
                                                    _vm.card.startDate,
                                                    _vm.lang
                                                  )
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("sub", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.tc("reservations.after")
                                                ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm._f("timeFilter")(
                                                      _vm.card.checkInTime
                                                    )
                                                  )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass: "icon icon-arrow-right",
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "date-out" }, [
                                        _c("div", {
                                          staticClass: "dash-label",
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.tc(
                                                "reservations.checkoutLabel"
                                              )
                                            ),
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "dash-content" },
                                          [
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("dayFilter")(
                                                    _vm.card.endDate
                                                  )
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("dateFilter")(
                                                    _vm.card.endDate,
                                                    _vm.lang
                                                  )
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("sub", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.tc("reservations.before")
                                                ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm._f("timeFilter")(
                                                      _vm.card.checkOutTime
                                                    )
                                                  )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "guests full-span-column cell--border-bottom cell--border-top",
                                      },
                                      [
                                        _c("div", {
                                          staticClass: "dash-label",
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.tc(
                                                "reservations.guestroomLabel"
                                              )
                                            ),
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "ul",
                                          {
                                            staticClass:
                                              "dash-content comma-lists",
                                          },
                                          [
                                            _c("li", {
                                              domProps: {
                                                innerHTML: _vm._s(_vm.guests),
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.isEnhancements
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "enhancements full-span-column cell--border-bottom",
                                          },
                                          [
                                            _c("div", {
                                              staticClass: "dash-label",
                                              domProps: {
                                                textContent: _vm._s(
                                                  _vm.tc(
                                                    "reservations.complimentaryLabel"
                                                  )
                                                ),
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "ul",
                                              {
                                                staticClass:
                                                  "dash-content comma-lists",
                                              },
                                              _vm._l(
                                                _vm.card.enhancements,
                                                function (enhancements, i) {
                                                  return _c("li", {
                                                    key: i + "-enhancement",
                                                    domProps: {
                                                      innerHTML:
                                                        _vm._s(enhancements),
                                                    },
                                                  })
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "full-span-column control",
                                      },
                                      [
                                        _vm.isUpcoming &&
                                        !_vm.card.hideEditPreferenceForUpcoming
                                          ? _c("a", {
                                              staticClass:
                                                "button--secondary black size-md outlined",
                                              attrs: {
                                                tabindex: _vm.flipped
                                                  ? "0"
                                                  : "-1",
                                                href: _vm.editPrefUrl,
                                              },
                                              domProps: {
                                                textContent: _vm._s(
                                                  _vm.tc(
                                                    "reservations.editPreferences"
                                                  )
                                                ),
                                              },
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.isUpcoming &&
                                        _vm.card.hideEditPreferenceForUpcoming
                                          ? _c("a", {
                                              staticClass:
                                                "button--primary white size-md",
                                              attrs: {
                                                href: _vm.contactUsUrl,
                                                tabindex: _vm.flipped
                                                  ? "0"
                                                  : "-1",
                                              },
                                              domProps: {
                                                textContent: _vm._s(
                                                  _vm.tc(
                                                    "reservations.contactUsLabel"
                                                  )
                                                ),
                                              },
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.card.hideModify && _vm.isUpcoming
                                          ? _c("a", {
                                              staticClass:
                                                "button--primary black size-md",
                                              attrs: {
                                                tabindex: _vm.flipped
                                                  ? "0"
                                                  : "-1",
                                              },
                                              domProps: {
                                                textContent: _vm._s(
                                                  _vm.tc(
                                                    "reservations.modifyLabel"
                                                  )
                                                ),
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.redirectUser(
                                                    _vm.card
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.isCancelled
                                          ? _c("a", {
                                              staticClass:
                                                "button--primary black size-md",
                                              attrs: {
                                                href: _vm.bookButtonUrl,
                                                tabindex: _vm.flipped
                                                  ? "0"
                                                  : "-1",
                                                target: "book",
                                              },
                                              domProps: {
                                                textContent: _vm._s(
                                                  _vm.tc(
                                                    "reservations.bookButton"
                                                  )
                                                ),
                                              },
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.isPast
                                          ? _c("a", {
                                              staticClass:
                                                "button--primary black size-md",
                                              attrs: {
                                                href: _vm.bookButtonUrl,
                                                tabindex: _vm.flipped
                                                  ? "0"
                                                  : "-1",
                                                target: "book",
                                              },
                                              domProps: {
                                                textContent: _vm._s(
                                                  _vm.tc(
                                                    "reservations.bookAgainButton"
                                                  )
                                                ),
                                              },
                                            })
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.flipped,
              callback: function ($$v) {
                _vm.flipped = $$v
              },
              expression: "flipped",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }